var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.36 21.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.26,21.36H5.1A5.11,5.11,0,0,1,0,16.26V5.1A5.11,5.11,0,0,1,5.1,0H16.26a5.11,5.11,0,0,1,5.1,5.1V16.26A5.11,5.11,0,0,1,16.26,21.36ZM5.1,2.06a3.05,3.05,0,0,0-3,3V16.26a3,3,0,0,0,3,3H16.26a3,3,0,0,0,3-3V5.1a3,3,0,0,0-3-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.68,16.31a5.63,5.63,0,1,1,5.63-5.63A5.64,5.64,0,0,1,10.68,16.31Zm0-9.2a3.57,3.57,0,1,0,3.57,3.57A3.58,3.58,0,0,0,10.68,7.11Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.22,
    cy: 4.83,
    r: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.54b1c5abe68e93720ac821ad75caaa3e.svg";
export { ForwardRef as ReactComponent };